import { useState, useEffect, useContext } from 'react'
import ContextStates from '../context/ContextStates'


const SearchAutoComplete = ({innerRef, ...props}) => {
    const [busqueda, setBusqueda] = useState([])
    const [pos, setPos] = useState(0)
    
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const { codigo, setCodigo, searchTerm, setSearchTerm } = useContext(ContextStates)
    

    useEffect(() => {
        if (codigo==='') {
            setSearchTerm('')
            setBusqueda([])
            setIsDropdownVisible(false)
        }
    }, [codigo])

    const filter = (item) => {
        let bus = item.target.value
        setSearchTerm(item.target.value)
        if (props.items) {
            if (item.target.value !== '') {
                let rData = []
                props.items.forEach(element => {
                    const palabrasCadena = element.label.toLowerCase().split(/\s+/);
                    const palabras = bus.toLowerCase().split(/\s+/);
                    if (palabras.every(palabraBuscada => {
                        const encontrado = palabrasCadena.some(palabraCadena => {
                            if (palabraCadena.includes(palabraBuscada)) {
                                return true;
                            }
                            return false;
                        });
                        return encontrado;
                    })) {
                        rData.push(element)
                    }
                });
                setBusqueda(rData)
            }
            else {
                setBusqueda([])
            }
        }
    }

    const handleItemSelect = (item) => {
        setSearchTerm(item.label);
        setCodigo(item.codigo)
        setIsDropdownVisible(false);
    };

    const handleKeyDown = (event) => {
        let posAct = pos;
        console.log("posi ",posAct)
        setIsDropdownVisible(true);
        setHighlightedIndex(posAct)
        if (event.key === 'ArrowDown') {
            if (posAct < busqueda.length - 1) {
                posAct++;
                setPos(posAct)
                
                setHighlightedIndex(posAct)
            }
        } else if (event.key === 'ArrowUp') {
            if (posAct > 0 - 1) {
                posAct--;
                setPos(posAct)
                
                setHighlightedIndex(posAct)
            }
        } else if (event.key === 'Enter') {
            if (highlightedIndex >= 0 && highlightedIndex < busqueda.length) {
                handleItemSelect(busqueda[highlightedIndex]);
            }
        }
    };

    return (
        <div className="w-full">
            <label htmlFor="descripcion" className="block text-gray-600 uppercase font-bold">Descripción</label>
            <input
                type='text'
                ref={innerRef}
                className="py-2 px-3 w-full rounded border border-gray-300"
                value={searchTerm}
                onChange={filter}
                onKeyDown={handleKeyDown}
                autoFocus
            />
            {isDropdownVisible && busqueda.length > 0 && (
                <ul
                    className='absolute mt-0 border border-gray-200 rounded-b-xl shadow-xl px-2 bg-white z-10'
                >
                    {busqueda.map((item, index) => (
                        <li
                            key={index}
                            onClick={() => handleItemSelect(item)}
                            className={`p-2 cursor-pointer ${highlightedIndex === index ? 'bg-blue-200' : 'bg-white'}`}
                        >
                            {item.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default SearchAutoComplete